import {Brick, registerBrick} from 'olympe';

export default class CreateFilterObjectForReadingWithFiltersOlympeDB extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} filters
     * @param {function()} forwardEvent
     * @param {function(*)} setFilters
     */
    update($, [filters], [forwardEvent, setFilters]) {
        const parsedFilters = JSON.parse(filters);
        const result = [];
        for (const [column, value] of Object.entries(parsedFilters)) {
            result.push({filterColumn: column, filterValue: value});
        }
        setFilters(result);
        forwardEvent();
    }
}

registerBrick('019914e8178e45049813', CreateFilterObjectForReadingWithFiltersOlympeDB);
